import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { TabGridComponent } from '../../../../../shared/components/tab-grid/tab-grid.component';
import {
  FormattedUseraliasData,
  TableDataSource,
} from '../../../../models/model';

@Component({
  selector: 'app-reset-password-userid-table',
  imports: [MatTableModule, MatRadioModule, TabGridComponent],
  templateUrl: './reset-password-userId-table.component.html',
  styleUrl: './reset-password-userId-table.component.scss',
})
export class ResetPasswordUserIdTableComponent implements OnChanges {
  isSelect = true;

  @Input() useraliaslist: FormattedUseraliasData[] = [];
  @Output() selectedRow: EventEmitter<FormattedUseraliasData> =
    new EventEmitter<FormattedUseraliasData>();

  userDataSource: TableDataSource<FormattedUseraliasData> = {
    data: [],
  };
  isResetPasswordPage = true;

  columnData = [
    {
      columnDef: 'selection',
      header: 'resetPassword.selection',
      cell: (el: FormattedUseraliasData) => `${el.selection}`,
      sortable: false,
      clickable: false,
      radioButton: true,
    },
    {
      columnDef: 'useralias',
      header: 'resetPassword.userID',
      cell: (el: FormattedUseraliasData) => `${el.useralias}`,
      sortable: true,
      clickable: false,
    },
    {
      columnDef: 'firstname',
      header: 'resetPassword.firstName',
      cell: (el: FormattedUseraliasData) => `${el.firstname}`,
      sortable: false,
      clickable: false,
    },
    {
      columnDef: 'lastname',
      header: 'resetPassword.lastName',
      cell: (el: FormattedUseraliasData) => `${el.lastname}`,
      sortable: false,
      clickable: false,
    },
    {
      columnDef: 'companyname',
      header: 'resetPassword.company',
      cell: (el: FormattedUseraliasData) => `${el.companyname}`,
      sortable: false,
      clickable: false,
    },
    {
      columnDef: 'city',
      header: 'resetPassword.location',
      cell: (el: FormattedUseraliasData) => `${el.city}`,
      sortable: false,
      clickable: false,
    },
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['useraliaslist']?.currentValue) {
      this.userDataSource.data = changes['useraliaslist']?.currentValue;
    }
  }

  onSelectedRow(row: FormattedUseraliasData) {
    this.selectedRow.emit(row);
  }
}
